import React, {useState} from "react";
import {serverRequest} from "../../../util/server_request";
import { useNavigate } from 'react-router-dom';
import {isFormComplete, notifyUser} from "../../../util/util";
import {Spin} from "antd";
import secureLocalStorage from "react-secure-storage";

// Clear onboarding storage after successful completion
const clearOnboardingStorage = () => {
    secureLocalStorage.removeItem('employerNumber');
    secureLocalStorage.removeItem('email');
};

export const PinSetup = () => {
    const navigate = useNavigate();

    const [form, setForm] = useState({pin:'', confirmPin:  ''})

    const [loading, setLoading] = useState(false)

    const toggleLoading = () => setLoading(prevState => !prevState)

    const changeHandler = (e) => setForm({...form, [e.target.name]: e.target.value})

    const setupPIN = () => {
        if (!isFormComplete(form)){
            return notifyUser('error', 'Please enter pin and confirm it to proceed!', 'Validation Error');
        }
        toggleLoading()
        
        // Get employerNumber from storage if available
        const employerNumber = secureLocalStorage.getItem('employerNumber')
        
        const payload = { ...form }
        // Include employerNumber in body if available
        if (employerNumber) {
            payload.employerNumber = employerNumber
        }
        
        serverRequest('POST', `users/pin/set-up`, payload)
          .then(result =>{
              toggleLoading()
              if (!result?.success){
                  notifyUser('error', result?.message, 'Error')
              }else{
                  notifyUser('success', 'PIN setup was successful!', 'Secure PIN')
                  secureLocalStorage.removeItem('token');
                  secureLocalStorage.removeItem('user');
                  secureLocalStorage.removeItem('expiresAt');
                  // Clear onboarding-specific storage
                  clearOnboardingStorage();
                  navigate('/onboard/success')
              }
          }).catch(error => {
              toggleLoading()
              notifyUser('error', error, 'Error')
          })
    }

    return (
        <div className='mx-auto mobile-full-width shadow bg-white p-5 rounded login-width'>
            <div align='center'>
                <p className='lead fw-bold'>Create Pin</p>
                <small className='text-center'>Enter a secure PIN.</small>

                <Spin spinning={loading}>
                    <div className="mt-4 w-75 mx-auto mobile-full-width">
                        <div className="mb-4">
                            <omk-otp-field
                                number-of-inputs="4"
                                resend-text=""
                                resend-button-label=""
                                label="Enter PIN"
                                name='pin'
                                className='mb-2' value={form.pin} onInput={changeHandler} />
                        </div>
                        <div className="mb-4">
                            <omk-otp-field
                                number-of-inputs="4"
                                resend-text=""
                                resend-button-label=""
                                label="Confirm PIN"
                                name='confirmPin'
                                className='mb-2' value={form.confirmPin} onInput={changeHandler} />
                        </div>

                        <p className="text-center omk-text-small text-black-50 mb-5"><i className="bi bi-shield-lock"/> Your information is confidential and secure</p>
                        <button className="btn btn-primary mb-4 w-50 mobile-full-width" onClick={setupPIN}>Continue</button>
                    </div>
                </Spin>
            </div>
        </div>
    )
}